import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { DevModeService } from './dev-mode.service';
import { FaleConoscoDialogComponent } from '@shared/components/fale-conosco-dialog/fale-conosco-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class FloatingMenuService {

  constructor(
    private _router: Router,
    private _devModeService: DevModeService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
  ) { }

  devPortal() {
    this._devModeService.enableDevMode(this._authenticationService.currentUser);
    this._router.navigate(['/assets/docs/devportal/RNPA Auto/index.html']);
  }

  home() {
    this._devModeService.disableDevMode(this._authenticationService.currentUser);
    this._router.navigate(['/dashboard']);
  }

  whatsApp() {
    window.open('https://wa.me/5521960105040', '_blank');
  }

  faleConosco() {
    this._modalService.open(FaleConoscoDialogComponent, {
      keyboard: false,
      centered: true,
      windowClass: 'modal-fale-conosco',
      backdropClass: 'modal-backdrop-formulario',
      scrollable: true,
    });
  }
}
